<div class="footer-container">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-xl-10">
                <div class="footer-content row bottom-border pt-4 pt-md-475 pb-4 pb-md-45">
                    <div class="col-lg-5 d-none d-md-block">
                        <div class="company-logo-img">
                            <a class="" [routerLink]="['/']">
                                <img src="assets/images/EoW_Horizontal_logo_TM_transparent_1.svg" alt="company-logo" />
                            </a>
                        </div>
                        <div class="pt-475 pb-45">
                            <span class="fnt-16 fw-b text-white">
                                {{ 'subscribe_to_our_newsletter' | translate }}
                            </span>
                            <div class="pt-25 d-flex">
                                <form [formGroup]="form" class="form-group">
                                    <div class="card subs-topInput">
                                        <p-multiSelect
                                            [options]="portals"
                                            [(ngModel)]="selectedPortals"
                                            [defaultLabel]="'which_newsletters' | translate"
                                            optionLabel="name"
                                            display="chip"
                                            class="mw-10"
                                            formControlName="subscribePortals"
                                        ></p-multiSelect>
                                    </div>
                                    <div>
                                        <input
                                            type="email"
                                            name="email1"
                                            formControlName="subscribeEmail"
                                            placeholder="What's your email address?"
                                            class="subs-topInput mx-auto-md-0 mx-auto mt-3 p-2"
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        (click)="subscribe()"
                                        class="mt-3 br-4 subscribe-button btn-raised"
                                        [disabled]="form?.get('subscribeEmail').invalid"
                                    >
                                        {{ 'submit' | translate }}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-between d-md-none">
                        <a class="company-logo-img d-inline-block" [routerLink]="['/']">
                            <img src="assets/images/EoW_Horizontal_logo_TM_transparent_1.svg" alt="company-logo" />
                        </a>
                        <div class="d-flex d-md-none">
                            <ng-container *ngTemplateOutlet="languageDropdown"></ng-container>
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="d-flex flex-wrap justify-content-md-between">
                            <div class="footer-menu">
                                <div class="pl-0 pr-0 text-content fnt-14 fw-m text-white pb-2">
                                    {{ 'menu_partners' | translate }}
                                </div>
                                <a class="menu-items" href="{{ env.publicWeb }}/coffee-roaster/" target="_blank">{{
                                    'roasters' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/estates/" target="_blank" x>{{
                                    'estates' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/facilitator/" target="_blank">{{
                                    'facilitators' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/hospitality/" target="_blank">{{
                                    'hospitality' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/micro-roaster/" target="_blank">{{
                                    'micro_roasters' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/consumer/" target="_blank">{{
                                    'consumers' | translate | titlecase
                                }}</a>
                            </div>
                            <div class="footer-menu">
                                <div class="pl-0 pr-0 text-content fnt-14 fw-m text-white pb-2">
                                    {{ 'company' | translate }}
                                </div>
                                <a class="menu-items" href="{{ env.publicWeb }}/contact/" target="_blank">{{
                                    'contact_us' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/privacy-policy/" target="_blank">{{
                                    'privacy_policy' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/terms-and-condition/" target="_blank">{{
                                    'terms_conditions' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/cookie-policy/" target="_blank">{{
                                    'cookie_policy' | translate
                                }}</a>
                            </div>
                            <div class="footer-menu">
                                <div class="pl-0 pr-0 text-content fnt-14 fw-m text-white pb-2">
                                    {{ 'about_us' | translate }}
                                </div>
                                <a class="menu-items" href="{{ env.publicWeb }}/aboutus/" target="_blank">{{
                                    'our_mission' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/solutions/" target="_blank">{{
                                    'solution' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/sustainability/" target="_blank">{{
                                    'sustainability' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/traceability/" target="_blank">{{
                                    'the_traceability_experience' | translate
                                }}</a>
                            </div>
                            <div class="footer-menu">
                                <div class="pl-0 pr-0 text-content fnt-14 fw-m text-white pb-2">
                                    {{ 'resouces' | translate }}
                                </div>
                                <a class="menu-items" href="{{ env.publicWeb }}/community-news/" target="_blank">{{
                                    'community_news' | translate
                                }}</a>
                                <a class="menu-items" href="{{ env.publicWeb }}/price-crisis/" target="_blank">{{
                                    'price_crisis' | translate
                                }}</a>
                                <a class="menu-items" routerLink="/{{ 'coffee' | translate }}/sitemap">{{
                                    'all_coffee_outlets' | translate
                                }}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="footer-content d-flex flex-column flex-md-row align-items-center px-2 px-md-0 py-4 py-md-475"
                >
                    <div class="d-md-none w-100 text-center">
                        <span class="w-100 text-center fnt-16 fw-b text-white">
                            {{ 'subscribe_to_our_newsletter' | translate }}
                        </span>
                        <div class="pt-25 d-flex justify-content-center">
                            <form [formGroup]="form" class="form-group">
                                <div class="card subs-topInput">
                                    <p-multiSelect
                                        [options]="portals"
                                        [(ngModel)]="selectedPortals"
                                        [defaultLabel]="'which_newsletters' | translate"
                                        optionLabel="name"
                                        display="chip"
                                        class="mw-10 subs-topInput"
                                        formControlName="subscribePortals"
                                    ></p-multiSelect>
                                </div>
                                <div>
                                    <input
                                        type="email"
                                        name="email1"
                                        formControlName="subscribeEmail"
                                        placeholder="What's your email address?"
                                        class="subs-topInput mx-auto-md-0 mx-auto mt-3 p-2"
                                    />
                                </div>
                                <button
                                    type="button"
                                    pButton
                                    pRipple
                                    label="{{ 'submit' | translate }}"
                                    (click)="subscribe()"
                                    class="mt-3 p-3"
                                ></button>
                            </form>
                        </div>
                    </div>
                    <div class="d-flex flex-column align-items-start align-items-sm-end">
                        <div class="social-media-logo d-flex mt-4 mt-md-0">
                            <a class="social-logo" href="https://www.facebook.com/eraofwe">
                                <img src="assets/images/facebook.svg" alt="social-Logo" />
                            </a>
                            <a class="social-logo" href="https://twitter.com/eraofweofficial">
                                <img src="assets/images/twitter.svg" alt="social-Logo" />
                            </a>
                            <a
                                class="social-logo"
                                href="https://www.instagram.com/accounts/login/?next=/eraofweofficial/"
                            >
                                <img src="assets/images/instagram.svg" alt="social-Logo" />
                            </a>
                            <a class="social-logo" href="https://www.linkedin.com/company/eraofwe/">
                                <img src="assets/images/youtube.svg" alt="social-Logo" />
                            </a>
                        </div>
                    </div>
                    <div class="d-flex flex-column col-xl-4 flex-md-row mt-4 mt-md-0">
                        <div class="fnt-14 fw-m text-white text-center opacity-07">
                            ©{{ currentDate | date: 'yyyy' }} SEWN Technology Solutions AB
                            {{ 'all_rights_reserved' | translate }}.
                        </div>
                    </div>
                    <div class="d-none d-md-flex flex-md-row">
                        <ng-container *ngTemplateOutlet="languageDropdown"></ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast key="myKey1" position="bottom-right" class="toast"></p-toast>

<ng-template #languageDropdown>
    <p-dropdown
        [options]="APP_LANGUAGES"
        [(ngModel)]="language"
        (onChange)="changeLang($event.value)"
        styleClass="no-border no-padding language"
    >
        <ng-template let-langage pTemplate="selectedItem">
            <span class="fnt-14 fnt-general fw-m text-white pl-1">
                <i class="pi pi-globe mr-1 align-middle fnt-14"></i>
                {{ langage.label }}
            </span>
        </ng-template>
    </p-dropdown>
</ng-template>
